exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.jumbo[data-v-9c1537ec] {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 5;\n}\n.img-container[data-v-9c1537ec] {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 4px;\n}\n", ""]);
